const apiBaseRoute = '/api/v1';

export const APPSTORE_URLS = {
    BASE_URL: import.meta.env.VITE_API_APPSTORE_URL,
    APP: {
        LIST: `${apiBaseRoute}/app/application`,
        SHOW: (alias) => `${apiBaseRoute}/app/application/${alias}`,
        STEPS: (alias) => `${apiBaseRoute}/app/application/${alias}/steps`,
        CREATE: `${apiBaseRoute}/app/application`,
        UPDATE: (alias) => `${apiBaseRoute}/app/application/${alias}`,
        DELETE: (alias) => `${apiBaseRoute}/app/${alias}`,
        STATUS: `${apiBaseRoute}/app/status`,
        CREDENTIALS: (alias) => `${apiBaseRoute}/app/application/${alias}/credentials`,
        PUBLISH: (alias) => `${apiBaseRoute}/app/application/${alias}/publish`,
        SOLICITATIONS: {
            LIST: (alias) => `${apiBaseRoute}/app/application/${alias}/solicitations`,
            SHOW: (alias, id) => `${apiBaseRoute}/app/application/${alias}/solicitations/${id}`,
            CREATE: (alias) => `${apiBaseRoute}/app/application/${alias}/solicitations`,
        },
        VERSIONS: {
            LIST: (alias) => `${apiBaseRoute}/app/application/${alias}/versions`,
            SHOW: (alias) => `${apiBaseRoute}/app/application/${alias}/versions/details`,
            CREATE: (alias) => `${apiBaseRoute}/app/application/${alias}/recreate-version`,
        },
        METRICS: {
            VISITS: (alias) => `${apiBaseRoute}/app/application/${alias}/metrics/visits`,
            INSTALLS: (alias) => `${apiBaseRoute}/app/application/${alias}/metrics/installs`,
            UNINSTALLS: (alias) => `${apiBaseRoute}/app/application/${alias}/metrics/uninstalls`,
        },
        UPLOAD: {
            IMAGE: (alias) => `${apiBaseRoute}/app/application/${alias}/upload-image`,
        },
    },
    ENVIRONMENT: {
        LIST: `${apiBaseRoute}/env/environment`,
        SHOW: (alias) => `${apiBaseRoute}/env/environment/${alias}`,
        CREATE: `${apiBaseRoute}/env/environment`,
        DELETE: (alias) => `${apiBaseRoute}/environment/${alias}`,
    },
    AUTH: {
        ME: `${apiBaseRoute}/auth/me`,
    },
    CATEGORY: {
        LIST: `${apiBaseRoute}/app/categories`,
    },
    PERMISSION: {
        LIST: `${apiBaseRoute}/app/permissions`,
    },
    REVIEW: {
        LIST: (alias) => `${apiBaseRoute}/app/application/${alias}/reviews`,
        SHOW: (alias, reviewId) => `${apiBaseRoute}/app/application/${alias}/reviews/${reviewId}`,
        RESUME: (alias) => `${apiBaseRoute}/app/application/${alias}/reviews/resume`,
        RESPOND: (alias, reviewId) => `${apiBaseRoute}/app/application/${alias}/reviews/${reviewId}/respond`,
    },
};
